module.exports = __webpack_public_path__ + "img/align-top-01.b855cfbe.svg";